/**
 * Turn a FastAPI error `detail` into a safe display string.
 *
 * `detail` may be a plain string, or a rejection object like
 * `{ message, reason, labels }` (e.g. a rejected question submission), or
 * missing. Passing the object straight into React state and rendering it throws
 * React error #31 ("Objects are not valid as a React child"), which blanks the
 * whole screen — so callers must always extract text through this helper.
 */
export function apiErrorText(detail: unknown, fallback: string): string {
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (detail && typeof detail === 'object') {
    const d = detail as Record<string, unknown>;
    if (typeof d.reason === 'string' && d.reason.trim()) return d.reason;
    if (typeof d.message === 'string' && d.message.trim()) return d.message;
  }
  return fallback;
}
